"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCashAdvanceRateAvailableFieldProposals = exports.createCashAdvanceRateEvaluator = exports.checkCashAdvanceRateConfigErrors = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const AvailableFormulaFields = {
    receivableEligibleExposureLessConcentrationLimitKickouts: 'Sum of all receivables eligible exposure less concentration limit kickouts',
    receivableBorrowingBaseAmount: 'Sum of all receivables borrowing base amounts',
};
/**
 *Cash advance rate formulas can use variables from CreditAgreement.Config.CashAdvanceRate.AvailableFormulaFields.
 */
const checkCashAdvanceRateConfigErrors = ({ cashAdvanceRateConfig, }) => {
    const availableFormulaFields = Object.keys(AvailableFormulaFields);
    const availableVariables = new Set(availableFormulaFields);
    (0, common_1.finleyAssert)(cashAdvanceRateConfig.type === 'formula', `unknown cashAdvanceRateConfig.type:[${cashAdvanceRateConfig.type}]`);
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(cashAdvanceRateConfig.config.formula, availableVariables);
    return errorMessages;
};
exports.checkCashAdvanceRateConfigErrors = checkCashAdvanceRateConfigErrors;
const createCashAdvanceRateEvaluator = (cashAdvanceRateConfig) => {
    // extract formula from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    (0, common_1.finleyAssert)(cashAdvanceRateConfig.type === 'formula', `Expected cash advance rate config type [${cashAdvanceRateConfig.type}] to be formula`);
    (0, common_1.finleyAssert)(cashAdvanceRateConfig.config.engineVersion ===
        finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${cashAdvanceRateConfig.config.engineVersion} is not yet supported for HyperForumla1 engine`);
    const formulaString = cashAdvanceRateConfig.config.formula;
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formulaString]);
    const evaluateConfig = (availableFields) => {
        const formulaInputs = common_1.utils.generateFlattenNestedKeyObject(availableFields);
        formulaEngine.setVariables(formulaInputs);
        return formulaEngine.evaluateNumber(formulaString);
    };
    return {
        evaluateConfig,
    };
};
exports.createCashAdvanceRateEvaluator = createCashAdvanceRateEvaluator;
const createCashAdvanceRateAvailableFieldProposals = () => {
    return lodash_1.default.map(lodash_1.default.toPairs(AvailableFormulaFields), ([key, description]) => ({
        label: `${key}`,
        documentation: description,
        insertText: `${key}`,
    }));
};
exports.createCashAdvanceRateAvailableFieldProposals = createCashAdvanceRateAvailableFieldProposals;
//# sourceMappingURL=cashAdvanceRateEvaluator.js.map